
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.87 14.816a19.434 19.434 0 0 1 1.574 2.328c.4.762.566 1.277.864 2.198.174.505.34.658.689.658.38 0 .555-.257.688-.658.279-.864.494-1.522.834-2.149 1.312-2.475 3.452-4.233 4.656-6.643 0 0 .793-1.472.793-3.533 0-1.92-.781-3.256-.781-3.256L6.874 14.832l-.005-.016Z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M3.71 10.29c.751 1.71 2.182 3.207 3.16 4.526l5.177-6.138s-.732.957-2.052.957a2.654 2.654 0 0 1-2.67-2.654c0-1.019.607-1.725.607-1.725-3.81.566-3.598 1.49-4.233 5.03l.012.004Z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M12.112.32c1.726.556 3.19 1.727 4.07 3.436L12.047 8.69s.607-.71.607-1.725c0-1.513-1.277-2.654-2.654-2.654-1.307 0-2.051.946-2.051.946.317-.723 3.598-4.69 4.168-4.934l-.005-.001Z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M4.655 2.491C5.684 1.267 7.488 0 9.979 0c1.203 0 2.116.32 2.116.32L7.944 5.251c-.28-.152-3.012-2.279-3.29-2.767v.006Z","fill":"#1A73E8"}}),_c('path',{attrs:{"d":"M3.71 10.29S3.033 8.942 3.033 7c0-1.84.72-3.452 1.628-4.494l3.289 2.768-4.234 5.015h-.004Z","fill":"#EA4335"}})])
          )
        }
      }
    